import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { ChatWidgetAction } from '@typesApp/ActionModule'
import { connectorActionModuleSelector } from '@redux/slices/connectorSlice'

type UseWebchatResult = {
  openWebchat: () => void
  hideWebchat: () => void
  toggleWebchat: () => void
  resetWebchat: () => void
  invokeWebchat: (action: ChatWidgetAction) => void
}

export const useWebchat = (): UseWebchatResult => {
  const actionModule = useSelector(connectorActionModuleSelector)

  const invokeWebchat = useCallback(
    (action: ChatWidgetAction) => {
      try {
        actionModule?.onChatWidgetAction(action)
      } catch (error) {
        console.error(error)
      }
    },
    [actionModule]
  )

  const openWebchat = useCallback(() => invokeWebchat('open'), [invokeWebchat])

  const hideWebchat = useCallback(() => invokeWebchat('hide'), [invokeWebchat])

  const toggleWebchat = useCallback(() => invokeWebchat('toggle'), [invokeWebchat])

  const resetWebchat = useCallback(() => invokeWebchat('reset'), [invokeWebchat])

  return {
    openWebchat,
    hideWebchat,
    toggleWebchat,
    resetWebchat,
    invokeWebchat,
  }
}
